<template>
    <div class="form-group">
        <label>Esitettävät kappaleet</label>
        <multiselect
            @select="onSelect"
            :options="songTypeOptions"
            :searchable="true"
            track-by="id"
            label="name"
            :options-limit="5"
            :allow-empty="false"
            placeholder="Valitse"
            selectLabel=""
            deselectLabel=""
            selectedLabel=""
            :show-no-results="false"
            :hide-selected="false"
            :value="selectedSongType">
            <span slot="noResult"></span>
        </multiselect>
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect';

    export default {
        model: {
            prop: 'selectedSongType',
            event: 'change'
        },
        components: {
            Multiselect
        },
        props: {
            songTypeOptions: {
                type: Array
            },
            selectedSongType: {
                type: Object,
                required: false
            }
        },
        methods: {
            onSelect(songtype) {
                this.$emit('change', songtype);
            }
        }
    };
</script>
